"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusType = void 0;
exports.StatusType = {
    FAILED: -1,
    OK: 1,
    OK_WITH_ERRORS: 2,
};
